export default __webpack_public_path__ + "static/media/lg-g.17d6859a.jpg";